
export const SET_USER = 'SET_USER';
export const SET_USER_ERROR = 'SET_USER_ERROR';